import { cva } from 'class-variance-authority'

import { eModeCategoryIdToName } from '@/domain/e-mode/constants'
import { EModeCategoryId } from '@/domain/e-mode/types'
import Flash from '@/ui/assets/components/flash.inline.svg'
import { cn } from '@/ui/utils/style'

export interface EModeBadgeProps {
  categoryId: EModeCategoryId
}

export function EModeBadge({ categoryId }: EModeBadgeProps) {
  const text = categoryId === 0 ? 'Enable' : eModeCategoryIdToName[categoryId]
  const state = categoryId === 0 ? 'off' : 'on'

  if (categoryId === 0) {
    return null
  }

  return (
    <div className={cn(variants({ state }))}>
      <Flash className="h-3.5 w-3.5" />
      {text}
    </div>
  )
}

const variants = cva('flex w-fit flex-row items-center gap-1.5 rounded-xs border px-1 py-0.5 font-semibold text-xs', {
  variants: {
    state: {
      on: 'border-primary bg-primary/10 text-primary uppercase',
      off: 'border-border bg-accent text-muted-foreground',
    },
  },
})
